import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Webservices } from '../../constants/routes/webservices.constant';
import { SyliusLocale } from '../../enums/i18n/locale.enum';
import { Channel, ChannelCode } from '../../models/dto/channel';
import { Response } from './abstract-http.service';
import { SsrHttpService } from './ssr-http.service';

@Injectable({
  providedIn: 'root',
})
export class ChannelHttpService extends SsrHttpService {
  public channel(
    code: ChannelCode,
    locale: SyliusLocale
  ): Observable<Channel | null> {
    return this.get<Channel>(Webservices.channel, {
      attrs: { code },
      params: { locale },
      response: Response.json,
    });
  }
}
